import { useCallback } from "react";
import { useAuth } from "react-oidc-context";

import { setIsAuthenticatingCookie } from "common/utilities/cookies";
import { useConst } from "common/utilities/useConst";

const VTYPE = "vtype";
const VTOKEN = "vtoken";

export const useSigninRedirect = () => {
  const auth = useAuth();

  const signinRedirect = useConst(() => auth.signinRedirect.bind(auth));

  return useCallback(() => {
    const { href, pathname, search } = location;
    const searchParameters = new URLSearchParams(search);
    const destinationParameter = searchParameters.get("destination");
    const hasVtypeAndVtoken = searchParameters.has(VTOKEN) && searchParameters.has(VTYPE);
    let redirectUri = href;
    if (destinationParameter) {
      // https://qa.intelligence.weforum.org/sso&desitnation=topics/asdfqwer&token=312532 => https://qa.intelligence.weforum.org/topics/asdfqwer
      redirectUri = `${import.meta.env.VITE_WEBSITE_URL}/${destinationParameter}`;
    }
    if (hasVtypeAndVtoken) {
      // more information about this in docs/ADR/authentication-vtype-vtoken.md
      const vTypeValue = searchParameters.get(VTYPE);
      const vTokenValue = searchParameters.get(VTOKEN);
      redirectUri = href
        .replace(`${VTYPE}=${vTypeValue}`, "")
        .replace(`${VTOKEN}=${vTokenValue}`, "")
        .replace("?&", "");
    }
    const resetPasswordFlow = pathname.includes("reset-password-login");
    if (resetPasswordFlow) redirectUri = import.meta.env.VITE_WEBSITE_URL;
    setIsAuthenticatingCookie(true);
    void signinRedirect({ redirect_uri: redirectUri });
  }, [signinRedirect]);
};
